export default __webpack_public_path__ + "static/media/candidate.work_learn_tab.overview.a4f562ab.jpg";